import React from "react";
import { Link } from "react-router-dom";
import { MapPin } from "lucide-react";
import { villesSEO, REGIONS } from "../../villes";
import { SectionTitle } from "./Helpers";

export default function CitiesSection() {
  return (
    <section className="py-20 section-vignette">
      <div className="container-narrow">
        <SectionTitle
          over="Zones d'intervention"
          title="Orléans, le Loiret et alentours"
          sub="Maître Diamma reçoit à son cabinet du centre d'Orléans et se déplace dans toute la métropole, le Loiret et les villes voisines. Consultations téléphoniques également possibles partout en France."
        />
        <div className="mt-10 grid lg:grid-cols-3 gap-6">
          {REGIONS.map(({ key, label }) => (
            <RegionCard key={key} region={label} villes={villesSEO.filter((v) => v.region === key)} />
          ))}
        </div>
      </div>
    </section>
  );
}

function RegionCard({ region, villes }) {
  return (
    <div className="card-onyx rounded-xl p-7">
      <div className="flex items-center gap-3 mb-4">
        <MapPin className="w-5 h-5 text-gold" />
        <h3 className="font-display text-xl text-gold">{region}</h3>
      </div>
      <div className="flex flex-wrap gap-2">
        {villes.map((v) => (
          <Link key={v.slug} data-testid={`home-city-link-${v.slug}`} to={`/marabout/${v.slug}`} className="text-xs px-3 py-1.5 rounded-full gold-border text-gold-soft/95 hover:bg-[rgba(212,168,56,0.12)] transition-colors">
            Marabout {v.nom}
          </Link>
        ))}
      </div>
    </div>
  );
}
